import { RouteConfig } from "vue-router";

import Customers from "../views/pages/admin/customers.vue";
import AdminLayout from "../views/layouts/admin/qMaster.vue";
import {
  CUSTOMER_TYPE,
  ROLE_ADMIN,
  ROLE_ADMIN_CUSTOMER,
} from "@/common/constant";
import OrderHistory from "@/views/pages/admin-customer/orderHistory.vue";

const adminCustomerRouter: Array<RouteConfig> = [
  {
    path: "/admin-customer",
    name: "admin-customer",
    component: AdminLayout,
    redirect: "admin-customer/default",
    meta: {
      allowRole: [ROLE_ADMIN_CUSTOMER],
    },
    children: [
      {
        path: "default",
        name: "admin-customer.default",
        redirect: "customers",
      },
      {
        path: "customers",
        name: "admin-customer.customers",
        component: Customers,
        meta: {
          pageTitle: "得意先注文者ID | 株式会社HORIKOSHI",
          title: "注文者ID一覧",
          subTitle:
            "当サービスから発注を行う注文者様のご登録をお願いいたします。",
          isShowImportTitle: true,
          className: "Customer",
          meta: {
            allowRole: [ROLE_ADMIN, ROLE_ADMIN_CUSTOMER],
          },
        },
      },
      {
        path: "order-histories",
        name: "admin-customer.order-histories",
        component: OrderHistory,
        meta: {
          pageTitle: "注文履歴 | 株式会社HORIKOSHI",
          title: "注文履歴",
          isShowLastOrderTimeTitle: false,
          className: "Order",
          meta: {
            allowRole: [CUSTOMER_TYPE, ROLE_ADMIN_CUSTOMER],
          },
        },
      },
    ],
  },
];

export default adminCustomerRouter;
